import "./styles.css";
import GenerateList from "./components/GenerateList";

function App() {
  return (
    <div className="App">
      <GenerateList />
    </div>
  );
}

export default App;
